import main from "react-chat-elements";

const mainDomain = "https://api.vpaedu.com/api/v1/";
const imageDomain = "https://api.vpaedu.com";

const NewConstants = {
  imageUrl: imageDomain,
  postUrls: {
    levels: mainDomain + "levels/list",
    courseBatchesByLevelId: mainDomain + "levels/batch-course",
    homeScreen: mainDomain + "home-screen/list",
    popup: mainDomain + "popup/list",
    announcement: mainDomain + "announcement/list",
    teams: mainDomain + "teams/list",
    batchDetails: mainDomain + "batches/details",
    galleryList: mainDomain + "gallery/list",
    results: mainDomain + "results/list",
    contact: mainDomain + "contact/create",
    courses: mainDomain + "courses/list",
  },
};

export default NewConstants;
